import Vue from 'vue'
import VueRouter from 'vue-router'

import index from '../views/index.vue' //首页
import huodong from '../views/huodong.vue' //主题活动
import licai from '../views/licai.vue' //理财课堂
import licai2 from '../views/licai2.vue' //理财课堂2
import touzi from '../views/touzi.vue' //投资有招
import levelThree from '../views/levelThree' //投资有招
import search from '../views/search' // 搜索
import dongjian from '../views/dongjian'
import banner from '../views/banner.vue'

Vue.use(VueRouter)
const routes = [
  { path: '/', name: 'index', component: index },
  { path: '/huodong', name: 'huodong', component: huodong },
  {
    path: '/licai',
    name: 'licai',
    component: licai,
  },
  {
    path: '/licai2',
    name: 'licai2',
    component: licai2,
  },
  { path: '/touzi', name: 'touzi', component: touzi },
  { path: '/levelThree', name: 'levelThree', component: levelThree },
  { path: '/search', name: 'search', component: search },
  { path: '/dongjian', name: 'dongjian', component: dongjian },
  { path: '/banner', name: 'banner', component: banner },
]

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
})
router.beforeEach((to, from, next) => {
  var u = navigator.userAgent
  var IOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //ios终端
  // 修复iOS版微信分享HTML5 History兼容性问题
  if (IOS && to.path !== location.pathname) {
    // 此处不能用location.replace
    location.assign(to.fullPath)
  } else {
    next()
  }
})
export default router
